import {BasicCriteria} from '../../../../allkey/framework/parameters/BasicCriteria';

export class ProcessStepExtCriteria extends BasicCriteria {
flowCode: string;
predefinedKind: string;
processCode: string;
visionCode: string;
}

